import api from "./apiBase";

function getMaterials() {
  return api.get("/materials");
}

export { getMaterials };
